/* eslint-disable prefer-destructuring */
import Dialog from 'quasar/src/plugins/Dialog.js';;
export default (function (_ref) {
  var store = _ref.store,
      app = _ref.app,
      router = _ref.router;
  document.addEventListener('deviceready', function () {
    if (typeof FirebasePlugin !== 'undefined') {
      // eslint-disable-next-line no-undef
      FirebasePlugin.hasPermission(function (hasPermission) {
        /*
        console.log('hasPermission', hasPermission);
        Dialog.create({
          title: 'hasPermission',
          message: hasPermission,
        });
         */
        if (!hasPermission) {
          // eslint-disable-next-line no-undef,no-unused-vars
          FirebasePlugin.grantPermission(function (grant) {
            /*
            console.log('grantPermission', grant);
            Dialog.create({
              title: 'grantPermission',
              message: grant,
            });
             */
          });
        }
      }); // eslint-disable-next-line

      FirebasePlugin.onTokenRefresh(function (token) {
        /*
        console.log('onTokenRefresh', token);
        Dialog.create({
          title: 'onTokenRefresh',
          message: token,
        });
         */
        if (token) {
          store.dispatch('user/updatePushToken', token);
        }
      }); // eslint-disable-next-line

      FirebasePlugin.onMessageReceived(function (message) {
        var title;

        if (message.title) {
          title = message.title;
        } else if (message.notification && message.notification.title) {
          title = message.notification.title;
        } else if (message.aps && message.aps.alert && message.aps.alert.title) {
          title = message.aps.alert.title;
        }

        var body;

        if (message.body) {
          body = message.body;
        } else if (message.notification && message.notification.body) {
          body = message.notification.body;
        } else if (message.aps && message.aps.alert && message.aps.alert.body) {
          body = message.aps.alert.body;
        }

        if (message.internalUrl) {
          Dialog.create({
            title: title || '',
            message: body,
            ok: app.i18n.t('dialog.ok'),
            cancel: app.i18n.t('dialog.showSpecial')
          }).onCancel(function () {
            router.push(message.internalUrl);
          });
        } else {
          Dialog.create({
            title: title || '',
            message: body
          });
        }
      }, function (error) {
        // eslint-disable-next-line
        console.error(error);
      });
    }
  }, false);
});